import {
  useGetCustomerPortalUrl,
  useGetProductType,
} from '@legacy/apis/indexAPI';
import { useVerifyDesignSevenPage } from '@legacy/apis/pagesAPI/designSevenAPI';
import { useGetShowSignUpButton } from '@legacy/apis/userSettingsAPI';
import { useGetCurrentPageIdentifier } from '@legacy/stores/PageStore';
import { OpenInNew } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { tlpOrigin } from '@/utils/gateway';

const onSignUpButtonClick = () => {
  const iframe = document.getElementById(
    'timelog-legacy-page-iframe',
  ) as HTMLIFrameElement;

  iframe?.contentWindow?.postMessage(
    { eventId: 'signUpButtonClicked' },
    tlpOrigin(),
  );
};

export const dataAutomationButtonId = 'HeaderSignUpButton';
export const dataAutomationLinkId = 'HeaderSignUpLink';

export const LegacySignUpButton = () => {
  const { t } = useTranslation('header');
  const currentPageIdentifier = useGetCurrentPageIdentifier();
  const { productType } = useGetProductType();
  const {
    isDesignSeven,
    isLoading: isLoadingIsDesignSeven,
    isError: isErrorCustomerPortalUrl,
  } = useVerifyDesignSevenPage(currentPageIdentifier);

  const {
    showSignUpButton,
    isLoading: isLoadingShowSignUpButton,
    isError: isErrorShowSignUpButton,
  } = useGetShowSignUpButton();

  const {
    customerPortalUrl,
    isLoading: isLoadingCustomerPortalUrl,
    isError: isErrorIsDesignSeven,
  } = useGetCustomerPortalUrl();

  const buttonText =
    productType === 'Time' ? t('TimeProductSignUpButton') : t('SignUpButton');
  const hasCustomerPortal =
    customerPortalUrl !== null &&
    customerPortalUrl !== '' &&
    customerPortalUrl !== undefined;
  const isNewPageAndDoNotUseCustomerPortal =
    !hasCustomerPortal && isDesignSeven;
  const isLegacyPageAndLetTLPDecideWhatToDo = !isDesignSeven;
  // This means no tracking as we only have that in TLP
  const isNewPageAndUseCustomerPortal = hasCustomerPortal && isDesignSeven;

  if (
    isLoadingShowSignUpButton ||
    isErrorShowSignUpButton ||
    isLoadingCustomerPortalUrl ||
    isErrorCustomerPortalUrl ||
    isLoadingIsDesignSeven ||
    isErrorIsDesignSeven
  ) {
    return null;
  }

  return showSignUpButton && !isNewPageAndDoNotUseCustomerPortal ? (
    <>
      {isNewPageAndUseCustomerPortal && (
        <Button
          href={`${customerPortalUrl}/signup`}
          target="_blank"
          rel="noreferrer"
          size="small"
          data-automation-id={dataAutomationLinkId}
          startIcon={<OpenInNew fill="#fff" />}
          variant="contained"
        >
          {buttonText}
        </Button>
      )}
      {isLegacyPageAndLetTLPDecideWhatToDo && (
        <Button
          size="small"
          data-automation-id={dataAutomationButtonId}
          variant="contained"
          onClick={onSignUpButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </>
  ) : null;
};
